/**
 * Portrait-oriented images (cards, lists, thumbnails, checkout, similar events).
 * Primary: event_portrait_image. Does not use event_landscape_image (wrong aspect for tiles).
 */
export function getEventPortraitImageUrl(ev: Record<string, unknown> | null | undefined): string | null {
  if (!ev || typeof ev !== 'object') return null;

  const portrait = ev['event_portrait_image'];
  if (typeof portrait === 'string' && portrait.trim()) return portrait.trim();

  const gallery = ev['image_gallery'];
  if (gallery) {
    if (Array.isArray(gallery) && gallery.length > 0) {
      const first = gallery[0] as unknown;
      if (typeof first === 'string' && first.trim()) return first.trim();
      if (first && typeof first === 'object') {
        const o = first as Record<string, unknown>;
        const u = o['url'] ?? o['image'];
        if (typeof u === 'string' && u.trim()) return u.trim();
      }
    } else if (typeof gallery === 'string' && gallery.trim()) {
      return gallery.trim();
    }
  }

  const portraitFallbacks = ['banner_image', 'image_url', 'banner_url', 'icon_url', 'image', 'poster_url'] as const;
  for (const k of portraitFallbacks) {
    const v = ev[k];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }

  return null;
}

/**
 * Wide / hero / carousel banners only.
 * Primary: event_landscape_image, then classic banner keys, portrait as last resort.
 */
export function getEventLandscapeImageUrl(ev: Record<string, unknown> | null | undefined): string | null {
  if (!ev || typeof ev !== 'object') return null;

  const landscape = ev['event_landscape_image'];
  if (typeof landscape === 'string' && landscape.trim()) return landscape.trim();

  const bannerKeys = ['banner_image', 'banner_url', 'image_url', 'image', 'poster_url'] as const;
  for (const k of bannerKeys) {
    const v = ev[k];
    if (typeof v === 'string' && v.trim()) return v.trim();
  }

  const gallery = ev['image_gallery'];
  if (gallery) {
    if (Array.isArray(gallery) && gallery.length > 0) {
      const first = gallery[0] as unknown;
      if (typeof first === 'string' && first.trim()) return first.trim();
      if (first && typeof first === 'object') {
        const o = first as Record<string, unknown>;
        const u = o['url'] ?? o['image'];
        if (typeof u === 'string' && u.trim()) return u.trim();
      }
    } else if (typeof gallery === 'string' && gallery.trim()) {
      return gallery.trim();
    }
  }

  const portrait = ev['event_portrait_image'];
  if (typeof portrait === 'string' && portrait.trim()) return portrait.trim();

  const icon = ev['icon_url'];
  if (typeof icon === 'string' && icon.trim()) return icon.trim();

  return null;
}

/** @deprecated Use getEventPortraitImageUrl — same behavior */
export function getEventImageUrl(ev: Record<string, unknown> | null | undefined): string | null {
  return getEventPortraitImageUrl(ev);
}

export function getEventPortraitImageUrlOrEmpty(ev: Record<string, unknown> | null | undefined): string {
  return getEventPortraitImageUrl(ev) ?? '';
}

export function getEventLandscapeImageUrlOrEmpty(ev: Record<string, unknown> | null | undefined): string {
  return getEventLandscapeImageUrl(ev) ?? '';
}

/** @deprecated Use getEventPortraitImageUrlOrEmpty — same behavior */
export function getEventImageUrlOrEmpty(ev: Record<string, unknown> | null | undefined): string {
  return getEventPortraitImageUrlOrEmpty(ev);
}
